import { render, staticRenderFns } from "./CostoTransportacion.vue?vue&type=template&id=8eab583a"
import script from "./CostoTransportacion.vue?vue&type=script&lang=js"
export * from "./CostoTransportacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports